import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import StyledLink from '../StyledLink';

const StyledContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  padding: '1rem',
  zIndex: 2,
  background: theme.palette.custom.cameraTitle,
}));

const StyledTitle = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  color: theme.palette.common.white,
  [theme.breakpoints.down('md')]: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
  },
}));

const StyledSubTitle = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  [theme.breakpoints.down('md')]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));

const StyledInfo = styled(Box)(({ theme }) => ({
  textAlign: 'right',
  [theme.breakpoints.down('md')]: {
    paddingLeft: '0.5rem',
  },
}));

export const CameraTitleWrapper = ({ children }) => (
  <StyledTitle component="span">{children}</StyledTitle>
);

CameraTitleWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const CameraTitleComponent = ({
  buildingId,
  buildingName,
  cameraName,
  userMessage,
  currentVideoTime,
}) => {
  const isCC = window.location.pathname.includes('call-center-dashboard');

  return (
    <StyledContainer>
      <StyledTitle>
        <StyledSubTitle>
          {buildingId && buildingName ? (
            <>
              {isCC ? (
                <span>{buildingName}</span>
              ) : (
                <StyledLink to={`/building/${buildingId}`}>
                  <CameraTitleWrapper>{buildingName}</CameraTitleWrapper>
                </StyledLink>
              )}
              <span>&nbsp;-&nbsp;</span>
            </>
          ) : null}
          <span>{cameraName}</span>
        </StyledSubTitle>
        {userMessage || currentVideoTime ? (
          <StyledInfo>{userMessage || currentVideoTime}</StyledInfo>
        ) : null}
      </StyledTitle>
    </StyledContainer>
  );
};

CameraTitleComponent.defaultProps = {
  userMessage: null,
  currentVideoTime: null,
};

CameraTitleComponent.propTypes = {
  buildingId: PropTypes.number.isRequired,
  buildingName: PropTypes.string.isRequired,
  cameraName: PropTypes.string.isRequired,
  userMessage: PropTypes.string,
  currentVideoTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CameraTitleComponent;
